import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cc94822&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5cc94822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc94822",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MobileSearchPanel: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/mobileSearchPanel.vue').default,SearchPanel: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/searchPanel.vue').default,Results: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/results.vue').default})
